<div class="card">
  <div class="facility-item" *ngFor="let card of data">
    <div class="icon">
      <!-- <div class="svg" [innerHTML]="card.item" [style.color]="card.color"></div> -->
      <img
        [src]="card.icon"
        [style.color]="card.color"
        alt="{{ card.title }}"
      />
    </div>
    <h3>{{ card.title }}</h3>
    <p>{{ card.description }}</p>
  </div>
</div>
